import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ConfirmModal } from '@app/shared/modals';
import { AppFilter } from '@app/shared/models';
import { SuiModalService, ModalSize } from '@richardlt/ng2-semantic-ui';
import { AuditTrailDetailModal } from 'src/modules/features/admin/modals';
import {
  NewDirectorModal,
  DirectorRecordModal,
  uploadDocumentsModal,
} from '../../../modals';
import { Subject } from 'rxjs';
import { map, take, takeUntil } from 'rxjs/operators';
import { NavigationStart, Router, ActivatedRoute } from '@angular/router';
import {
  CompanyService,
  DashboardProvider,
  DocumentService,
  OrganizationService,
} from '../../../services';
import { ViewHistoryModal } from '../../../modals/view-history-modal/view-history-modal.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NewPersonnelModal } from '../../../modals/new-personnel-modal/new-personnel-modal.component';
import { CompanyOwnershipService } from '@app/shared/services/company-ownership.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-company-personnel',
  templateUrl: './company-personnel.component.html',
  styleUrls: ['./company-personnel.component.scss'],
})
export class CompanyPersonnelComponent implements OnInit {
  companyDirectors = [];
  initialDirectors = [];
  success: any;
  error: any;
  unsubscribe$: Subject<boolean> = new Subject();
  pending: boolean;
  filter: AppFilter = new AppFilter();
  totalItems: number = 0;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  organizationId: string;
  companyType: Array<any> = [];
  baseUrl = environment.API_SERVER;
  ownershipType: Array<any> = [];
  countries: Array<any> = [];
  isEdit: boolean = false;
  isPending: boolean = false;
  chatLink;
  companyShareholderForm: FormGroup;
  currentForm: any;
  changeRequestId;
  result = [];
  documents = [];

  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'firstName',
        op: 'cn',
        data: '',
      },
      {
        field: 'lastName',
        op: 'cn',
        data: '',
      },
    ],
  };
  optionFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'optionType.optionTypeId',
        op: 'eq',
        data: 'individual_ownership_type',
      },
    ],
  };
  directorStatus: string;
  message;
  redirect_url;
  applicationType;
  affiliateTypeName!: string;
  affiliateTypeId!: string;
  companyTypeId = JSON.parse(window.localStorage.getItem('user')).organizationId
    .jpaContractor.companyType.optionId;
  allStatus: any;
  typeStructure!: string;
  subject = new Subject<boolean>();
  personnelStructureKeys!: string[];
  structureObject: any;
  pendingArr: boolean[] = [];
  companyAffiliateTypes;
  allAffiliateTypes;
  allStructures = [];
  redirect_params: any;
  organization;
  constructor(
    private modalService: SuiModalService,
    private location: Location,
    private dashboardSvc: DashboardProvider,
    private companySvc: CompanyService,
    private organizationSvc: OrganizationService,
    private fb: FormBuilder,
    private documentSvc: DocumentService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private companyOwnershipService: CompanyOwnershipService
  ) {
    this.message = window.localStorage.getItem('message');
    this.applicationType = window.localStorage.getItem('application_type');
    this.redirect_url = window.localStorage.getItem('redirect_url');
    this.redirect_params = window.localStorage.getItem('redirect_params')
      ? JSON.parse(window.localStorage.getItem('redirect_params'))
      : null;
    this.organizationId = window.localStorage.getItem('organizationId');
    this.organization = JSON.parse(window.localStorage.getItem('user'));
    this.filter = new AppFilter({ sidx: 'dateCreated', rows: 10 });
    // this.getVerificationStatus();
    // this.getPage(1);
    this.getCountry();
    this.getOptionTypes();
    this.getAffiliateTypes(this.companyTypeId);
    this.chatLink = `/contractor/chat/${this.organizationId}/message`;
    this.companyShareholderForm = fb.group({
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      middleName: [''],
      gender: ['', Validators.required],
      nationalityId: ['', Validators.required],
      countryOfOriginId: ['', Validators.required],
      nationalIdNumber: ['', Validators.required],
      organizationOwnershipTypeId: [''],
      shareholding: [''],
      actionType: [''],
      organizationOwnershipId: [''],
    });
    this.currentForm = this.companyShareholderForm.value;

    // GET PERSONNEL TYPE
    this.activatedRoute.queryParams.subscribe((params) => {
      this.affiliateTypeId = params.typeId;
      this.affiliateTypeName = params.typeName;
      this.filter.rows = 10;
      this.isEdit = false;
      this.filter.filters = JSON.stringify(this.searchFilter);
      this.getPage(1);
      this.getVerificationStatus();
      this.result = [];
      this.documents = [];
      this.nullify();
      // this.upload();
    });

    // this.affiliateTypeId = this.activatedRoute.snapshot.queryParams.typeId;
    // this.affiliateTypeName = this.activatedRoute.snapshot.queryParams.typeName;
    // this.isEdit = false;
    // this.filter.filters = JSON.stringify(this.searchFilter);
    // this.getPage(1);
    // this.getVerificationStatus();
    // this.result = [];
    // this.documents = [];
    // this.nullify();
  }

  redirectToExternalUrl() {
    // Build the URL with query parameters
    const urlWithParams = this.buildUrlWithParams(
      this.redirect_url,
      this.redirect_params
    );

    // Redirect to the external URL
    window.location.href = urlWithParams;
  }

  private buildUrlWithParams(
    url: string,
    params: { [key: string]: any }
  ): string {
    const queryParams = Object.keys(params)
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
      )
      .join('&');

    return queryParams ? `${url}?${queryParams}` : url;
  }

  getAffiliateTypes(companyTypeId: string) {
    if (companyTypeId == 'public_company_limited_by_shares_actual') {
      companyTypeId = 'limited_liability';
    }
    this.companyOwnershipService
      .getOwnershipsForCompanyType({ companyTypeId: companyTypeId })
      .subscribe(
        (res: any[]) => {
          this.companyAffiliateTypes = res;
          this.getAllAfiliateTypes();
        },
        (error) => {
          console.log(error);
          this.pending = false;
        }
      );
  }
  getAllAfiliateTypes() {
    this.companyOwnershipService.getOwnershipTypes().subscribe(
      (res: any[]) => {
        this.allAffiliateTypes = res;
        let t = setInterval(() => {
          if (this.pending == false) {
            clearInterval(t);
          }

          if (this.companyAffiliateTypes) {
            this.companyAffiliateTypes.forEach((companyAffiliateType) => {
              this.allAffiliateTypes.every((affiliateType) => {
                if (
                  companyAffiliateType.ownershipType == affiliateType.optionName
                ) {
                  companyAffiliateType.ownershipTypeId = affiliateType.optionId;
                  return false;
                }
                return true;
              });
            });
            console.log(
              this.companyAffiliateTypes,
              'this.companyAffiliateTypes'
            );
            this.companyAffiliateTypes.map((item) => {
              this.getStructure(1, item.ownershipTypeId);
            });
            this.pending = false;
            clearInterval(t);
          }
        }, 200);
      },
      (error) => {
        this.pending = false;
        console.log(error);
      }
    );
  }
  getStructure(page, data) {
    this.filter.page = page;
    this.pending = true;
    this.companySvc
      .getCompanyDirector({
        organizationId: this.organizationId,
        // ownershipType: 'shareholder_type',
        ownershipType: data,
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          res.rows.map((item) => {
            this.allStructures.push(item);
          });
          this.pending = false;
          console.log(res.rows, this.allStructures, 'new');
          console.log(this.allStructures, 'this.allStructures');
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  getCountry() {
    this.companySvc.getCountries({ filter: null }).subscribe((res) => {
      this.countries = res['rows'];
    });
  }

  getOptionTypes() {
    this.companySvc
      .getOptions({ filter: JSON.stringify(this.optionFilter) })
      .pipe(map((res: any) => res.rows))
      .subscribe((res) => {
        this.ownershipType = res;
      });
  }

  updateForm(data, index) {
    this.nullify();

    this.companyShareholderForm.value.actionType = 'DELETE';
    this.currentForm = this.companyShareholderForm.value;
    this.currentForm['actionType'] = 'DELETE';
    this.companyShareholderForm.value.organizationOwnershipId =
      data.organizationOwnershipId;
    this.currentForm['organizationOwnershipId'] = data.organizationOwnershipId;
    const {
      countryOfOriginId,
      firstName,
      lastName,
      middleName,
      gender,
      nationalIdNumber,
      nationalityId,
      organizationOwnershipId,
      organizationOwnershipTypeId,
      shareholding,
    } = data;
    const newObj = {
      actionType: 'DELETE',
      countryOfOriginId,
      firstName,
      lastName,
      middleName,
      gender,
      nationalIdNumber,
      nationalityId,
      organizationOwnershipId,
      organizationOwnershipTypeId,
      shareholding,
    };
    let payload = {
      fromValue: newObj,
      toValue: this.companyShareholderForm.value,
    };
    this.addToChanges(payload, 'DELETE', index);
    this.success = 'Record Deleted';
  }
  checkifisthesame(data) {
    console.log(data);
    const organizationOwnershipIds = data.map((o) => o.organizationOwnershipId);
    const filtered = data.filter(
      ({ organizationOwnershipId }, index) =>
        !organizationOwnershipIds.includes(organizationOwnershipId, index + 1)
    );
    return filtered;
  }
  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    this.companySvc
      .getCompanyDirector({
        organizationId: this.organizationId,
        ownershipType: this.affiliateTypeId,
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.totalItems = +res.records;
          this.rows = this.filter.rows;
          this.companyDirectors = res['rows'];
          this.initialDirectors = res['rows'];
          this.pending = false;
        },
        (error) => {
          this.pending = false;
          this.error = error.error.errorMessage
            ? error.error.errorMessage
            : error.error
            ? error.error
            : error;
        }
      );
  }

  addCompany() {}
  viewCompany(event) {
    this.modalService
      .open(
        new AuditTrailDetailModal(
          'Row Data',
          'Are you sure you want to delete this Lot plan?',
          ModalSize.Tiny
        )
      )
      .onApprove((payload) => {
        // this.addWorkflowGroup(payload);
      })
      .onDeny(() => {});
  }
  getCountryName(cou) {
    let con = this.countries.filter((con) => con.countryCode == cou);
    if (con[0]) {
      return con['countryName'];
    } else {
      return cou;
    }
  }

  getOwnership(cou) {
    let con = this.ownershipType.filter((con) => con.optionId == cou);
    if (con[0]) {
      return con['optionName'];
    } else {
      return cou;
    }
  }

  viewHistory() {
    this.modalService.open(
      new ViewHistoryModal('View History', this.typeStructure, {
        isPending: false,
      })
    );
  }
  dataAdded;
  addDirector() {
    console.log(this.result, 'result');
    this.modalService
      .open(
        new NewPersonnelModal(
          'New Personnel',
          {
            countries: this.countries,
            companyType: this.companyType,
            ownershipType: this.ownershipType,
            // item: 'SHAREHOLDER_STRUCTURE',
            item: this.typeStructure,
            affiliateTypeId: this.affiliateTypeId,
            affiliateTypeName: this.affiliateTypeName,
            companyTypeId: this.companyTypeId,
          },
          false,
          ModalSize.Tiny
        )
      )
      .onApprove((obj) => {
        console.log(obj, 'checkheretoda');
        this.dataAdded = { obj };
        this.returnData();
        return;
      })
      .onDeny(() => {});
  }
  returnData() {
    this.dataAdded;
    console.log(this.dataAdded, 'thisismydata');
    if (this.dataAdded.obj.affiliateTypes.length > 1) {
      let value: any = {};
      this.dataAdded.obj.affiliateTypes.forEach((affiliateType) => {
        value = this.dataAdded.obj;
        value.toValue = { ...value.toValue, ...affiliateType };
        this.addToChanges(value, 'ADD', 1);
      });
    } else {
      this.addToChanges(this.dataAdded.obj, 'ADD', 1);
    }
    console.log(this.structureObject);
    let data = {
      fromValue: this.dataAdded.obj.fromValue,
      toValue: this.dataAdded.obj.toValue,
    };
    this.result.push(data);
    console.log(this.result, 'newest result');
    // this.dataAdded.obj.document.map((item) => this.documents.push(item));
    console.log(this.documents, 'documentss');
    // this.documents.push(this.dataAdded.obj.document);
  }
  addToChanges(values: any, actionType: string, index: number) {
    let data = {
      fromValue: values.fromValue,
      toValue: values.toValue,
    };
    let ownershipTypeName =
      values.toValue?.ownershipTypeName || this.affiliateTypeName;
    // let ownershipTypeId = values.toValue?.organizationOwnershipTypeId?.replace(/_type/g, "");
    let structureType = this.personnelStructureKeys.find(
      (key) => key.toLowerCase().includes(ownershipTypeName?.toLowerCase())
      // || key.toLowerCase().includes(ownershipTypeId?.toLowerCase())
    );
    if (
      data.toValue.organizationOwnershipTypeId === 'shareholder_type' ||
      data.toValue.ownershipTypeName === 'Shareholder'
    ) {
      (data.toValue.shareholderType = data.toValue.shareholderType
        ? data.toValue.shareholderType
        : 'Individual'),
        (data.toValue.shareholding = data.toValue.share);
    } else {
      data.toValue.shareholding = '0';
    }
    this.structureObject[structureType].result.push(data);
    if (values.document) {
      values.document.map((item) =>
        this.structureObject[structureType].documents.push(item)
      );
    }

    this.restrctureData(data, actionType, index);
  }
  checkDisabled() {
    if (this.typeStructure === 'SHAREHOLDER_STRUCTURE') {
      return !(
        this.returnTotalShareholding() >= 99 &&
        this.returnTotalShareholding() <= 100
      );
    } else {
      return false;
    }
  }
  returnTotalShareholding() {
    let totalShareholding2 = 0;
    if (this.companyDirectors.length > 0) {
      totalShareholding2 = this.companyDirectors.reduce(
        (sum, item) => sum + item.shareholding,
        0
      );
    }
    return totalShareholding2;
  }
  hasChanges() {
    for (let key in this.structureObject) {
      if (this.structureObject[key]['result'].length > 0) {
        return true;
      }
    }
    return false;
  }
  cancelUpdate() {
    this.modalService
      .open(
        new ConfirmModal(
          'Cancel Updates',
          'Are you sure you want to cancel these updates?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.structureObject['DIRECTOR_STRUCTURE'].result = [];
        this.structureObject['SHAREHOLDER_STRUCTURE'].result = [];
        this.structureObject['COMPANY SECRETARY_STRUCTURE'].result = [];
        this.pendingArr.splice(0);
        this.filter.rows = 10;
        this.isEdit = false;
        this.getPage(1);
      });
  }

  edit(director, index) {
    this.modalService
      .open(
        new NewPersonnelModal(
          'Edit Personnel',
          {
            // director: director,
            director: {
              ...director,
              organizationOwnershipTypeId: this.affiliateTypeId,
              ownershipTypeName: this.affiliateTypeName,
            },
            countries: this.countries,
            companyType: this.companyType,
            ownershipType: this.ownershipType,
            item: this.typeStructure,
            // item: 'SHAREHOLDER_STRUCTURE',
            affiliateTypeId: this.affiliateTypeId,
            affiliateTypeName: this.affiliateTypeName,
            companyTypeId: this.companyTypeId,
          },
          true,
          ModalSize.Tiny
        )
      )
      .onApprove((values: any) => {
        if (values.affiliateTypes.length > 1) {
          let value: any = {};
          values.affiliateTypes.forEach((affiliateType) => {
            value = values;
            value.toValue = { ...value.toValue, ...affiliateType };
            this.addToChanges(value, 'UPDATE', index);
          });
        } else {
          this.addToChanges(values, 'UPDATE', index);
        }
        console.log(this.structureObject);
        // let data = {
        //   fromValue: values.fromValue,
        //   toValue: values.toValue,
        // };
        // console.log(data);
        // this.result.push(data);
        // this.documents.push(values.document);
      })
      .onDeny(() => {});
  }

  upload() {
    this.modalService
      .open(
        new uploadDocumentsModal(
          'Upload Documents',
          {
            countries: this.countries,
            companyType: this.companyType,
            ownershipType: this.ownershipType,
            // item: 'SHAREHOLDER_STRUCTURE',
            item: this.typeStructure,
          },
          true,
          ModalSize.Tiny
        )
      )
      .onApprove((values: any) => {
        this.documents.push(values.document);
      })
      .onDeny(() => {});
  }

  directorRecord(director) {
    this.modalService
      .open(
        new DirectorRecordModal(
          'Personnel Details',
          {
            director: director,
            countries: this.countries,
            companyType: this.companyType,
            ownershipType: this.ownershipType,
            item: this.typeStructure,
            // item: 'SHAREHOLDER_STRUCTURE',
          },
          ModalSize.Tiny
        )
      )
      .onApprove(() => {})
      .onDeny(() => {});
  }

  checkDoc() {
    if (this.documents.length > 0) {
      this.isEdit = false;
      this.saveActionDirector();
    } else {
      this.upload();
    }
  }
  restrctureData(item, actionType, currentIndex) {
    // this.companyDirectors = this.initialDirectors;
    // this.structureObject.SHAREHOLDER_STRUCTURE.result.forEach((item) => {
    const organizationOwnershipId = item.toValue.organizationOwnershipId;
    if (actionType === 'ADD') {
      // If actionType is "ADD", push the toValue object to data2
      const newObject = {
        ...item.toValue,
        createdBy: JSON.stringify({
          name: this.organization.firstName + ' ' + this.organization.lastName,
          username: this.organization.username,
          appUserId: this.organization.appUserId,
          organizationId: this.organization.organizationId.organizationId,
          organizationName:
            this.organization.organizationId.organizationShortName,
        }),
        dateCreated: new Date().toISOString(),
      };
      this.companyDirectors.unshift(newObject);
    } else if (actionType === 'UPDATE') {
      // If actionType is "UPDATE", find the object with the same organizationOwnershipId in data2
      if (organizationOwnershipId) {
        const index = this.companyDirectors.findIndex(
          (obj) => obj.organizationOwnershipId === organizationOwnershipId
        );
        if (index !== -1) {
          // If object exists, merge the toValue object with the existing object in data2
          this.companyDirectors[index] = {
            ...this.companyDirectors[index],
            ...item.toValue,
          };
        }
      } else {
        this.companyDirectors[currentIndex] = {
          ...this.companyDirectors[currentIndex],
          ...item.toValue,
        };
      }
    } else if (actionType === 'DELETE') {
      // If actionType is "DELETE", find the object with the same organizationOwnershipId in data2 and delete it
      if (organizationOwnershipId) {
        const index = this.companyDirectors.findIndex(
          (obj) => obj.organizationOwnershipId === organizationOwnershipId
        );
        if (index !== -1) {
          // If object exists, delete it from data2
          this.companyDirectors.splice(index, 1);
        }
      } else {
        // If object exists, delete it from data2
        this.companyDirectors.splice(currentIndex, 1);
      }
    }
    // });
  }
  saveDirector() {
    if (this.hasChanges() && this.checkDisabled() === false) {
      this.saveActionDirector();
    } else {
      this.error = 'Please perform an action';
    }
  }

  structure = [];
  dataSubmitted = [];
  saveActionDirector() {
    this.modalService
      .open(
        new ConfirmModal(
          'Save Updates',
          'Are you sure you want to save these updates?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        console.log(this.structureObject, this.allStructures);
        for (let key in this.structureObject) {
          console.log(key, 'key');
          if (this.structureObject[key]['result'].length > 0) {
            this.allStructures.filter((item) => {
              const keys = item.ownershipTypeIdName
                .map((obj) => Object.keys(obj))
                .flat();
              if (
                keys.includes(
                  this.structureObject[key]['result'][0].toValue
                    .organizationOwnershipTypeId
                )
              ) {
                this.dataSubmitted.push(item);
              }
            });
          }
        }
        console.log(this.dataSubmitted, ' this.dataSubmitted');
        const filteredArray = this.dataSubmitted.filter(
          (obj, index, self) =>
            index ===
            self.findIndex(
              (t) => t.organizationOwnershipId === obj.organizationOwnershipId
            )
        );
        console.log(filteredArray);
        let data = filteredArray.filter(
          (elem) =>
            !this.result.find(
              ({ toValue }) =>
                elem.organizationOwnershipId === toValue.organizationOwnershipId
            )
        );
        data.map((item) => {
          const keys = item.ownershipTypeIdName
            .map((obj) => Object.keys(obj))
            .flat();
          let dataSent = {
            countryOfOriginId: item.countryOfOriginId,
            firstName: item.firstName,
            gender: item.gender,
            lastName: item.lastName,
            middleName: item.middleName,
            nationalIdNumber: item.nationalIdNumber,
            nationalityId: item.nationalityId,
            organizationOwnershipId: item.organizationOwnershipId,
            organizationOwnershipTypeId: item.organizationOwnershipTypeId,
            shareholding: item.shareholding,
            photographDocumentId: item.photographDocumentId,
            photographDocumentPath: item.photographDocumentPath,
            ownershipTypeIdName: item.ownershipTypeIdName,
            ownershipTypeName: item.ownershipTypeName,
            documents: item.documents,
            actionType: '',
            shareholderType: item.shashareholderType
              ? item.shareholderType
              : keys[0] === 'shareholder_type'
              ? 'Individual'
              : '',
          };
          console.log(dataSent, 'filtered');
          return this.structure.push(dataSent);
        });

        this.saveAll();
      });
  }
  checkKeys(keys) {
    if (keys[0] === 'shareholder_type') {
      return 'Individual';
    } else {
      return '';
    }
  }
  nullify() {
    this.success = '';
    this.error = '';
  }

  saveAll() {
    console.log(this.structureObject, 'object');
    for (let key in this.structureObject) {
      console.log(key, 'key');
      if (this.structureObject[key]['result'].length > 0) {
        this.pendingArr.push(true);
        let toValue = [];
        let fromValue = [];
        let result = this.structureObject[key]['result'];
        console.log(result, 'result');
        result.map((item) => {
          toValue.push(item.toValue);
          fromValue.push(item.fromValue);
        });
        this.structure.map((data) => {
          fromValue.push(data);
        });

        // let resultFrom = this.checkifisthesame(fromValue);
        // let resultTo = this.checkifisthesame(toValue);

        let resultFrom = fromValue;
        let resultTo = toValue;
        console.log(resultTo, 'result');
        const shareholderLess = resultTo.filter((item) => {
          return item.shareholding < 10;
        });
        // const shareholderLess = [];
        const notShareholderLess = resultTo.filter((item) => {
          return item.shareholding >= 0;
        });
        const fromResult = resultFrom.filter((item) => {
          return item.actionType !== 'ADD';
        });
        if (key === 'SHAREHOLDER_STRUCTURE' && shareholderLess.length > 0) {
          console.log('youhithere1');
          let payload = {
            organization: {
              organizationId: this.organizationId,
            },
            changeRequestType: key,
            // changeRequestType: 'SHAREHOLDER_STRUCTURE',
            actionType: 'UPDATE',
            fromValue: JSON.stringify(fromResult),
            toValue: JSON.stringify(shareholderLess),
          };
          console.log(shareholderLess, 'here');
          // this.addRequestImmediately(payload, key);
          // this.addRequest(payload, key);
        }
        if (key !== 'SHAREHOLDER_STRUCTURE' && shareholderLess.length > 0) {
          console.log('youhithere2');
          this.companyDirectors = this.companyDirectors.map((director) => {
            if (!director.hasOwnProperty('actionType')) {
              director.actionType = 'NONE';
            }
            if (
              director.actionType === 'UPDATE' &&
              !director.organizationOwnershipId
            ) {
              director.actionType = 'ADD';
            }
            return director;
          });
          const newArray = fromResult
            .map((director) => {
              if (
                (director.actionType === 'UPDATE' ||
                  director.actionType === 'DELETE') &&
                !director.organizationOwnershipId
              ) {
                return null; // Return null for elements to be deleted
              }
              return director;
            })
            .filter(Boolean);
          let payload = {
            organization: {
              organizationId: this.organizationId,
            },
            changeRequestType: key,
            // changeRequestType: 'SHAREHOLDER_STRUCTURE',
            actionType: 'UPDATE',
            fromValue: JSON.stringify(newArray),
            toValue: JSON.stringify(this.companyDirectors),
          };
          this.addRequest(payload, key);
        }
        if (key === 'SHAREHOLDER_STRUCTURE' && notShareholderLess.length > 0) {
          console.log('youhithere3');
          this.companyDirectors = this.companyDirectors.map((director) => {
            if (!director.hasOwnProperty('actionType')) {
              director.actionType = 'NONE';
            }
            if (
              director.actionType === 'UPDATE' &&
              !director.organizationOwnershipId
            ) {
              director.actionType = 'ADD';
            }
            return director;
          });
          const newArray = fromResult
            .map((director) => {
              if (
                director.actionType === 'UPDATE' &&
                !director.organizationOwnershipId
              ) {
                return null; // Return null for elements to be deleted
              }
              return director;
            })
            .filter(Boolean);
          let payload = {
            organization: {
              organizationId: this.organizationId,
            },
            changeRequestType: key,
            // changeRequestType: 'SHAREHOLDER_STRUCTURE',
            actionType: 'UPDATE',
            fromValue: JSON.stringify(newArray),
            toValue: JSON.stringify(this.companyDirectors),
          };
          console.log(notShareholderLess, 'nothere');
          this.addRequest(payload, key);
        }
      }
    }
  }
  addRequest(payload, key) {
    console.log(payload, 'greater');
    this.organizationSvc
      .addChangeRequest({
        organizationId: this.organizationId,
        body: payload,
      })
      .subscribe(
        (res) => {
          let changeRequestId = res['changeRequestId'];
          this.structureObject[key].result = [];
          this.pendingArr.splice(0);
          if (this.pendingArr.length == 0) {
            this.isEdit = false;
            this.filter.rows = 10;
            this.success =
              'Submit successful. You will be notified when your request has been verified';
            this.getVerificationStatus();
            this.getPage(1);
          }
        },
        (error) => {
          this.pendingArr.splice(0);
          console.log(this.pendingArr, 'pendingArr');
          if (this.pendingArr.length == 0) {
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error.message
              ? error.error.message
              : error.error
              ? error.error
              : error;
          }
        }
      );
  }
  addRequestImmediately(payload, key) {
    console.log(payload, 'less');
    this.organizationSvc
      .updateChangeRequestImmediately({
        organizationId: this.organizationId,
        body: payload,
      })
      .subscribe(
        (res) => {
          this.structureObject[key].result = [];
          this.pendingArr.splice(0);
          if (this.pendingArr.length == 0) {
            this.isEdit = false;
            this.success = 'Shareholder update successful';
            this.getVerificationStatus();
            this.getPage(1);
          }
        },
        (error) => {
          this.pendingArr.splice(0);
          if (this.pendingArr.length == 0) {
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error
              ? error.error
              : error;
          }
        }
      );
  }

  onUploadFile(data, changeRequestId: string) {
    this.nullify();
    this.pendingArr.push(true);
    this.documentSvc
      .uploadSupportingDocument({
        changeRequestId: changeRequestId,
        body: data,
      })
      .subscribe(
        (res) => {
          this.pendingArr.pop();
          if (this.pendingArr.length == 0) {
            this.isEdit = false;
            this.filter.rows = 10;
            this.success =
              'Personnel information updated successfully. You will be notified when your request has been verified';
            this.getVerificationStatus();
            this.getPage(1);
          }
        },
        (error) => {
          this.pendingArr.pop();
          if (this.pendingArr.length == 0) {
            this.error = error.error.errorMessage
              ? error.error.errorMessage
              : error.error
              ? error.error
              : error;
          }
        }
      );
    // this.nullify();
    // this.pending = true;
    // this.documentSvc
    //   .uploadSupportingDocument({
    //     changeRequestId: changeRequestId,
    //     body: data,
    //   })
    //   .subscribe(
    //     (res) => {
    //       this.pending = false;
    //       this.success =
    //         'Personnel information updated successfully. You will be notified when your request has been verified';
    //       this.getVerificationStatus();
    //     },
    //     (error) => {
    //       this.pending = false;
    //       this.error = error.error;
    //     }
    //   );
  }

  viewUpdates() {}

  updateDirector() {
    this.modalService
      .open(
        new ConfirmModal(
          'Make Updates',
          `Are you sure you want to make updates to your ${this.affiliateTypeName}s ?`,
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.filter.rows = 1000;
        this.isEdit = true;
        this.getPage(1);
      });
  }

  createStructureObject() {
    this.structureObject = {};
    this.personnelStructureKeys.forEach((key) => {
      this.structureObject[key] = {
        result: [],
        documents: [],
      };
    });
  }

  getVerificationStatus() {
    let organization = JSON.parse(window.localStorage.getItem('organization'));
    this.dashboardSvc
      .getStatus({
        organizationId: organization.organizationId,
      })
      .subscribe(
        (res) => {
          this.allStatus = res;
          this.personnelStructureKeys = Object.keys(res).filter((key) =>
            key.includes('STRUCTURE')
          );
          this.createStructureObject();
          let statusKeys = Object.keys(this.allStatus);
          this.typeStructure = statusKeys.find((statusKey) =>
            statusKey
              .toLowerCase()
              .includes(this.affiliateTypeName.toLowerCase())
          );
          console.log(this.typeStructure, 'typestructure');
          this.directorStatus = res[this.typeStructure];
          // this.directorStatus = res['SHAREHOLDER_STRUCTURE'];
          // res['SHAREHOLDER_STRUCTURE'] === 'UNVERIFIED' ||
          // res['SHAREHOLDER_STRUCTURE'] === 'PENDING'
          //   ? (this.isPending = true)
          //   : (this.isPending = false);
          ['PENDING'].includes(res[this.typeStructure])
            ? (this.isPending = true)
            : (this.isPending = false);
        },
        (error) => {
          // this.error = error.error.errorMessage ? error.error.errorMessage
          //                                       : error.error ? error.error
          //                                       : error;
        }
      );
  }

  onDelete() {}

  deleteItem(director, index) {
    this.companyShareholderForm.patchValue(director);
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Record',
          'Are you sure you want to delete this Record?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.updateForm(director, index);
      })
      .onDeny(() => {});
  }

  goBack() {
    this.location.back();
  }

  searchRecords(search) {
    let searchFilter = this.searchFilter;
    searchFilter.rules[0].data = search;
    searchFilter.rules[1].data = search;
    // searchFilter.rules[2].data = search;
    this.filter.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }

  //handle sorting records
  sortRecords(search) {
    this.filter.sord = search;
    // this.filter.sidx = 'firstName';
    this.getPage(1);
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }

  ngOnInit(): void {
    this.router.events.pipe(takeUntil(this.unsubscribe$)).subscribe((event) => {
      if (
        event instanceof NavigationStart &&
        event.url != `/contractor/company/shareholder`
      ) {
        localStorage.removeItem('message');
        localStorage.removeItem('application_type');
        localStorage.removeItem('redirect_url');
      }
    });
  }

  confirmNavigationFromPage() {
    if (this.hasChanges()) {
      this.modalService
        .open(
          new ConfirmModal(
            'Discard Changes',
            'You have unsaved changes, do you want to leave this page and discard them?'
          )
        )
        .onApprove(() => {
          this.subject.next(true);
        })
        .onDeny(() => {
          this.subject.next(false);
        });
    } else {
      setTimeout(() => this.subject.next(true), 1);
    }
    // if (this.result?.length) {
    //   this.modalService.open(new ConfirmModal(
    //     "Discard Changes",
    //     "You have unsaved changes, do you want to leave this page and discard them?"
    //   ))
    //   .onApprove(() => {this.subject.next(true)})
    //   .onDeny(() => {this.subject.next(false)})
    // }
    // else {
    //   setTimeout(() => this.subject.next(true), 1);
    // }
  }
}
